import React, { createContext, useContext, useState } from "react";
import {
  useLocalStorage,
  useSessionStorage,
  useLocalCartStorage
} from "../../../helpers/useStorage";

const ActivitiesContext = createContext();

export function useActivitiesContext() {
  return useContext(ActivitiesContext);
}

const ActivitiesProvider = (props) => {
  const [quotation, setQuotation] = useState({});
  const [tourPassangerData, setTourPassangerData] = useState([]);
  const [activitiesCart, setActivitiesCart] = useSessionStorage(
    "activitiesCart",
    {}
  );

  const [activitiesCheckOutData, setActivitiesCheckOutData] = useSessionStorage(
    "activitiesCheckOutData",
    {}
  );

  const [tourNameImage, setTourNameImage] = useLocalStorage(
    "tourNameImage",
    null
  );
  const [activitiesLocalCart, setActivitiesLocalCart] = useLocalCartStorage(
    "Cart",
    {}
  );

  const [searchReqBuildActivities, setSearchReqBuildActivities] =
    useLocalStorage("searchReqBuildActivities", {});

  const [selectedBuildActivities, setSelectedBuildActivities] = useSessionStorage(
    "selectedBuildActivities",
    []
  );

  const [selectedBuildHotel, setSelectedBuildHotel] = useSessionStorage(
    "selectedBuildHotel",
    []
  );

  const [isCartUpdating, setIsCartUpdating] = useState(false);


  return (
    <ActivitiesContext.Provider
      value={{
        state: {
          tourNameImage,
          tourPassangerData,
          activitiesCart,
          activitiesCheckOutData,
          searchReqBuildActivities,
          selectedBuildActivities,
          selectedBuildHotel,
          quotation,
          activitiesLocalCart,
          isCartUpdating
        },
        setActivitiesCart,
        setActivitiesLocalCart,
        setActivitiesCheckOutData,
        setTourNameImage,
        setTourPassangerData,
        setSearchReqBuildActivities,
        setSelectedBuildActivities,
        setSelectedBuildHotel,
        setQuotation,
        setIsCartUpdating
      }}
    >
      {props.children}
    </ActivitiesContext.Provider>
  );
};

export default ActivitiesProvider;
